import { Component, Input, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-sl-avatar',
  standalone: true,
  imports: [NgIf],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <sl-avatar
      [image]="image"
      [label]="label"
      [shape]="shape"
      [size]="size"
      class="avatar-component">
      <ng-content></ng-content>
    </sl-avatar>
  `,
  styleUrls: ['./sl-avatar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SlAvatarComponent {
  @Input() image?: string;
  @Input() label?: string;
  @Input() shape: 'circle' | 'square' | 'rounded' = 'circle';
  @Input() size: 'small' | 'medium' | 'large' | 'x-large' = 'medium';
}
